
import CountDown from "./countdown/CountDown";
import SignUp from "./signup/SignUp";
import SignUpDesktop from "./signup/SignUpDekstop";

export const Home = () => {
  return (
   <body class="body">
  <div class="page-wrapper">
   
      
      <div
  data-animation="over-right"
  className="navbar w-nav"
  data-easing2="ease-out-quart"
  data-easing="ease-out-quart"
  data-collapse="all"
  data-w-id="7db522e6-ec44-21a3-9107-5afbcbb8b5b4"
  role="banner"
  data-no-scroll={1}
  data-duration={600}
  id="hero"
  data-doc-height={1}
>
  <section className="navigation">
    <div className="nav mob">
      <a href="#" className="logo-holder w-inline-block">
        <img
          sizes="(max-width: 1080px) 100vw, 1080px"
          srcSet="images/High_Table_Logo-p-500.png 500w, images/High_Table_Logo-p-800.png 800w, images/High_Table_Logo.png 1080w"
          alt="logo"
          src="images/High_Table_Logo.png"
          loading="lazy"
          className="logo"
        />
      </a>
      <div className="acc-box">
        <img
          data-w-id="62ebab89-e0dd-ac2d-e1aa-9e6565bb21bb"
          loading="lazy"
          alt="burger menu"
          src="images/68d2a4bcf12df49bee20818d_menu-ico.svg"
          className="menu-icon"
        />
      </div>
    </div>
    <div className="nav">
      <a href="#" className="logo-holder w-inline-block">
        <img
          sizes="(max-width: 1080px) 100vw, 1080px"
          srcSet="images/High_Table_Logo-p-500.png 500w, images/High_Table_Logo-p-800.png 800w, images/High_Table_Logo.png 1080w"
          alt="Hobi logo"
          src="images/High_Table_Logo.png"
          loading="lazy"
          className="logo"
        />
      </a>
      <div className="acc-box">
        <a href="#" className="nav-link">
          ABOUT
        </a>
      
        <a href="#" className="button-2 nav w-button">
          LOGIN
        </a>
      <SignUpDesktop/>
      </div>
    </div>
    <div className="mob-menu-container">
      <div className="close-wrap">
        <img
          data-w-id="62ebab89-e0dd-ac2d-e1aa-9e6565bb21d0"
          loading="lazy"
          alt="close"
          src="images/close.svg"
          className="close"
        />
      </div>
      <a
        href="#"
        data-w-id="62ebab89-e0dd-ac2d-e1aa-9e6565bb21ca"
        className="nav-link mob"
      >
        ABOUT
      </a>
  
      <div className="mob-btns-wrap">
        <a
          href="#"
          data-w-id="62ebab89-e0dd-ac2d-e1aa-9e6565bb21cc"
          className="su-button mob-menu w-inline-block"
        >
          <div>LOGIN</div>
        </a>
        <SignUp />
      </div>
    </div>
  </section>
</div>

      <section className="section is-hero">
  <div className="padding-global">
    <div className="container-large">
      <div className="wrapper is-hero-content">
        <div className="overflow-hidden">
          <h1
            data-w-id="1d63d54d-63ab-aa30-3346-d2fc733aa8f9"
            style={{ opacity: 0 }}
            className="dine-title"
          >
            Dine with
            <br />
            Strangers
          </h1>
          <div
            data-w-id="f348af72-1cd1-e491-816d-6a861d808330"
            style={{ opacity: 0 }}
            className="text-size-large semi-bold"
          >
            Everybody is a stranger...
            <br />
            until you meet them.
          </div>
          <div
            data-w-id="f957931e-428a-984b-77cf-ed7bc7f20577"
            style={{ opacity: 0 }}
            className="cta-btn"
          >
            <a href="https://stage-dashboard.hightable.ai" className="button-2 home-cta w-button">
              Book Your Seat
            </a>
          </div>
        </div>
        <div className="overflow-hidden">
          <h1
            data-w-id="4541068a-e3b9-f1df-d422-15ce312642d2"
            style={{ opacity: 0 }}
            className="dine-title t2"
          >
            Get ready for your next social adventure
          </h1>
          <div
            data-w-id="4541068a-e3b9-f1df-d422-15ce312642d4"
            style={{ opacity: 0 }}
            className="text-size-large semi-bold next-table"
          >
            NEXT TABLE IN
          </div>
        </div>
      <CountDown/>
      </div>
    </div>
  </div>
</section>

      <section className="section">
  <div
    data-w-id="b412ddb3-5b65-48f3-24dc-c5de5dddf8e5"
    style={{ width: 0 }}
    className="divider-line"
  />
  <div className="padding-global">
    <div className="container-large">
      <div className="padding-vertical">
        <div className="wrapper is-wood-intro">
          <div className="overflow-hidden">
            <h1
              data-w-id="519398f3-1953-d7bd-e892-275437d8b7f8"
              style={{ opacity: 0 }}
              className="dine-title"
            >
              How does it{" "}
              <span className="text-span">
                <em className="italic-text">WORK?</em>
              </span>
            </h1>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<section className="section">
  <div
    data-w-id="9cb07b43-fe60-4c8c-adc5-e0af9e2e5130"
    style={{ width: 0 }}
    className="divider-line"
  />
  <div className="padding-global nopad">
    <div className="container-large">
      <div className="padding-vertical">
        <div className="w-layout-grid grid is-wood">
          <div
            id="w-node-_9cb07b43-fe60-4c8c-adc5-e0af9e2e5129-656a3cad"
            className="column wood-left"
          >
            <div
              data-w-id="1ad9cb0e-07f5-d6b7-51a1-8435dd7fff11"
              style={{ width: 1, height: 0 }}
              className="divider-line vertical"
            />
            <div className="section-title">
              <div className="text-subtitle">Hightable</div>
              <div className="overflow-hidden">
                <h2
                  data-w-id="122f9993-537e-db56-504c-109b6639ae67"
                  style={{
                    WebkitTransform:
                      "translate3d(0, 105%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                    MozTransform:
                      "translate3d(0, 105%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                    msTransform:
                      "translate3d(0, 105%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                    transform:
                      "translate3d(0, 105%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)"
                  }}
                  className="heading"
                >
                  Pull up a seat, meet someone new, and enjoy real
                  conversations. We handle the planning, you just show up.
                </h2>
              </div>
            </div>
          </div>
          <div
            id="w-node-_9cb07b43-fe60-4c8c-adc5-e0af9e2e512c-656a3cad"
            className="column wood-right"
          >
            <div className="wood-component-wrapper">
              <div className="wood-component-item">
                <div
                  data-w-id="07e34d62-9007-31fb-64db-b8dc8e5275a7"
                  className="image-wrapper wood"
                >
                  <img
                    src="images/WhatsApp-Image-2025-10-01-at-6.15.43-PM-1.jpeg"
                    loading="lazy"
                    style={{
                      WebkitTransform:
                        "translate3d(0, 0, 0) scale3d(1.2, 1.2, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                      MozTransform:
                        "translate3d(0, 0, 0) scale3d(1.2, 1.2, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                      msTransform:
                        "translate3d(0, 0, 0) scale3d(1.2, 1.2, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                      transform:
                        "translate3d(0, 0, 0) scale3d(1.2, 1.2, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)"
                    }}
                    sizes="(max-width: 1080px) 100vw, 1080px"
                    alt=""
                    srcSet="images/WhatsApp-Image-2025-10-01-at-6.15.43-PM-1-p-500.jpeg 500w, images/WhatsApp-Image-2025-10-01-at-6.15.43-PM-1-p-800.jpeg 800w, images/WhatsApp-Image-2025-10-01-at-6.15.43-PM-1.jpeg 1080w"
                    className="image-fill"
                  />
                  <div
                    style={{
                      display: "block",
                      WebkitTransform:
                        "translate3d(0, 0%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                      MozTransform:
                        "translate3d(0, 0%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                      msTransform:
                        "translate3d(0, 0%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                      transform:
                        "translate3d(0, 0%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)"
                    }}
                    className="image-overlay"
                  />
                </div>
                <div className="wood-component-content">
                  <div className="divider-line" />
                  <div className="wood-component-title">
                    <h4>01. answer a few questions</h4>
                    <a href="#" className="wood-component-link w-inline-block">
                      <div className="wood-component-icon">
                        <div className="wood-component-icon_arrow w-embed">
                          <svg
                            version="1.1"
                            id="Ebene_1"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlnsXlink="http://www.w3.org/1999/xlink"
                            x="0px"
                            y="0px"
                            width="100%"
                            height="100%"
                            viewBox="0 0 14 14"
                            style={{ enableBackground: "new 0 0 14 14" }}
                            xmlSpace="preserve"
                          >
                            <style
                              type="text/css"
                              dangerouslySetInnerHTML={{
                                __html:
                                  "\t.st0{fill:none;stroke:currentcolor;stroke-width:1.25;stroke-linecap:square;stroke-linejoin:round;}\t.st1{fill:none;stroke:currentcolor;stroke-width:1.25;stroke-linecap:square;}"
                              }}
                            />
                            <path className="st0" d="M1.5,7H12" />
                            <path
                              className="st1"
                              d="M8.8,2.9L12.8,7l-4.1,4.1"
                            />
                          </svg>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div className="wood-component-text">
                    <div>
                      Tell us a bit about your preferences so we can find the
                      perfect table for you.
                    </div>
                  </div>
                </div>
              </div>
              <div className="wood-component-item">
                <div
                  data-w-id="6a70b8cb-9557-f7b2-4ff6-5f64b85c1494"
                  className="image-wrapper wood"
                >
                  <img
                    src="images/WhatsApp-Image-2025-10-01-at-6.15.45-PM.jpeg"
                    loading="lazy"
                    style={{
                      WebkitTransform:
                        "translate3d(0, 0, 0) scale3d(1.2, 1.2, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                      MozTransform:
                        "translate3d(0, 0, 0) scale3d(1.2, 1.2, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                      msTransform:
                        "translate3d(0, 0, 0) scale3d(1.2, 1.2, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                      transform:
                        "translate3d(0, 0, 0) scale3d(1.2, 1.2, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)"
                    }}
                    sizes="(max-width: 1080px) 100vw, 1080px"
                    alt=""
                    srcSet="images/WhatsApp-Image-2025-10-01-at-6.15.45-PM-p-500.jpeg 500w, images/WhatsApp-Image-2025-10-01-at-6.15.45-PM-p-800.jpeg 800w, images/WhatsApp-Image-2025-10-01-at-6.15.45-PM.jpeg 1080w"
                    className="image-fill"
                  />
                  <div
                    style={{
                      display: "block",
                      WebkitTransform:
                        "translate3d(0, 0%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                      MozTransform:
                        "translate3d(0, 0%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                      msTransform:
                        "translate3d(0, 0%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                      transform:
                        "translate3d(0, 0%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)"
                    }}
                    className="image-overlay"
                  />
                </div>
                <div className="wood-component-content">
                  <div className="divider-line" />
                  <div className="wood-component-title">
                    <h4>02. explore table</h4>
                    <a href="#" className="wood-component-link w-inline-block">
                      <div className="wood-component-icon">
                        <div className="wood-component-icon_arrow w-embed">
                          <svg
                            version="1.1"
                            id="Ebene_1"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlnsXlink="http://www.w3.org/1999/xlink"
                            x="0px"
                            y="0px"
                            width="100%"
                            height="100%"
                            viewBox="0 0 14 14"
                            style={{ enableBackground: "new 0 0 14 14" }}
                            xmlSpace="preserve"
                          >
                            <style
                              type="text/css"
                              dangerouslySetInnerHTML={{
                                __html:
                                  "\t.st0{fill:none;stroke:currentcolor;stroke-width:1.25;stroke-linecap:square;stroke-linejoin:round;}\t.st1{fill:none;stroke:currentcolor;stroke-width:1.25;stroke-linecap:square;}"
                              }}
                            />
                            <path className="st0" d="M1.5,7H12" />
                            <path
                              className="st1"
                              d="M8.8,2.9L12.8,7l-4.1,4.1"
                            />
                          </svg>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div className="wood-component-text">
                    <div>
                      Browse tables, discover people, and choose what sparks
                      your curiosity.
                    </div>
                  </div>
                </div>
              </div>
              <div className="wood-component-item">
                <div
                  data-w-id="48390d96-27c3-9a92-c494-0288b4503a7a"
                  className="image-wrapper wood"
                >
                  <img
                    src="images/WhatsApp-Image-2025-10-01-at-6.15.44-PM-1.jpeg"
                    loading="lazy"
                    style={{
                      WebkitTransform:
                        "translate3d(0, 0, 0) scale3d(1.2, 1.2, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                      MozTransform:
                        "translate3d(0, 0, 0) scale3d(1.2, 1.2, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                      msTransform:
                        "translate3d(0, 0, 0) scale3d(1.2, 1.2, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                      transform:
                        "translate3d(0, 0, 0) scale3d(1.2, 1.2, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)"
                    }}
                    sizes="(max-width: 1080px) 100vw, 1080px"
                    alt=""
                    srcSet="images/WhatsApp-Image-2025-10-01-at-6.15.44-PM-1-p-500.jpeg 500w, images/WhatsApp-Image-2025-10-01-at-6.15.44-PM-1-p-800.jpeg 800w, images/WhatsApp-Image-2025-10-01-at-6.15.44-PM-1.jpeg 1080w"
                    className="image-fill"
                  />
                  <div
                    style={{
                      display: "block",
                      WebkitTransform:
                        "translate3d(0, 0%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                      MozTransform:
                        "translate3d(0, 0%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                      msTransform:
                        "translate3d(0, 0%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                      transform:
                        "translate3d(0, 0%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)"
                    }}
                    className="image-overlay"
                  />
                </div>
                <div className="wood-component-content">
                  <div className="divider-line" />
                  <div className="wood-component-title">
                    <h4>03. show up</h4>
                    <a href="#" className="wood-component-link w-inline-block">
                      <div className="wood-component-icon">
                        <div className="wood-component-icon_arrow w-embed">
                          <svg
                            version="1.1"
                            id="Ebene_1"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlnsXlink="http://www.w3.org/1999/xlink"
                            x="0px"
                            y="0px"
                            width="100%"
                            height="100%"
                            viewBox="0 0 14 14"
                            style={{ enableBackground: "new 0 0 14 14" }}
                            xmlSpace="preserve"
                          >
                            <style
                              type="text/css"
                              dangerouslySetInnerHTML={{
                                __html:
                                  "\t.st0{fill:none;stroke:currentcolor;stroke-width:1.25;stroke-linecap:square;stroke-linejoin:round;}\t.st1{fill:none;stroke:currentcolor;stroke-width:1.25;stroke-linecap:square;}"
                              }}
                            />
                            <path className="st0" d="M1.5,7H12" />
                            <path
                              className="st1"
                              d="M8.8,2.9L12.8,7l-4.1,4.1"
                            />
                          </svg>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div className="wood-component-text">
                    <div>
                      No planning, no stress—just arrive and start connecting.
                    </div>
                  </div>
                </div>
              </div>
              <div className="wood-component-item">
                <div
                  data-w-id="782abab4-7c17-b037-38e7-da9cb5c5cfec"
                  className="image-wrapper wood"
                >
                  <img
                    src="images/WhatsApp-Image-2025-10-01-at-6.15.43-PM.jpeg"
                    loading="lazy"
                    style={{
                      WebkitTransform:
                        "translate3d(0, 0, 0) scale3d(1.2, 1.2, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                      MozTransform:
                        "translate3d(0, 0, 0) scale3d(1.2, 1.2, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                      msTransform:
                        "translate3d(0, 0, 0) scale3d(1.2, 1.2, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                      transform:
                        "translate3d(0, 0, 0) scale3d(1.2, 1.2, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)"
                    }}
                    sizes="(max-width: 1080px) 100vw, 1080px"
                    alt=""
                    srcSet="images/WhatsApp-Image-2025-10-01-at-6.15.43-PM-p-500.jpeg 500w, images/WhatsApp-Image-2025-10-01-at-6.15.43-PM-p-800.jpeg 800w, images/WhatsApp-Image-2025-10-01-at-6.15.43-PM.jpeg 1080w"
                    className="image-fill"
                  />
                  <div
                    style={{
                      display: "block",
                      WebkitTransform:
                        "translate3d(0, 0%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                      MozTransform:
                        "translate3d(0, 0%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                      msTransform:
                        "translate3d(0, 0%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                      transform:
                        "translate3d(0, 0%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)"
                    }}
                    className="image-overlay"
                  />
                </div>
                <div className="wood-component-content">
                  <div className="divider-line" />
                  <div className="wood-component-title">
                    <h4>04. dive into experiences</h4>
                    <a href="#" className="wood-component-link w-inline-block">
                      <div className="wood-component-icon">
                        <div className="wood-component-icon_arrow w-embed">
                          <svg
                            version="1.1"
                            id="Ebene_1"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlnsXlink="http://www.w3.org/1999/xlink"
                            x="0px"
                            y="0px"
                            width="100%"
                            height="100%"
                            viewBox="0 0 14 14"
                            style={{ enableBackground: "new 0 0 14 14" }}
                            xmlSpace="preserve"
                          >
                            <style
                              type="text/css"
                              dangerouslySetInnerHTML={{
                                __html:
                                  "\t.st0{fill:none;stroke:currentcolor;stroke-width:1.25;stroke-linecap:square;stroke-linejoin:round;}\t.st1{fill:none;stroke:currentcolor;stroke-width:1.25;stroke-linecap:square;}"
                              }}
                            />
                            <path className="st0" d="M1.5,7H12" />
                            <path
                              className="st1"
                              d="M8.8,2.9L12.8,7l-4.1,4.1"
                            />
                          </svg>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div className="wood-component-text">
                    <div>
                      Enjoy conversations, laughter, and moments you won’t
                      forget.
                    </div>
                  </div>
                </div>
              </div>
              <div className="wood-component-item">
                <div
                  data-w-id="36bfe94d-29b1-fa5a-8eca-1d9c81bf58c4"
                  className="image-wrapper wood"
                >
                  <img
                    src="images/WhatsApp-Image-2025-10-01-at-6.15.44-PM.jpeg"
                    loading="lazy"
                    style={{
                      WebkitTransform:
                        "translate3d(0, 0, 0) scale3d(1.2, 1.2, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                      MozTransform:
                        "translate3d(0, 0, 0) scale3d(1.2, 1.2, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                      msTransform:
                        "translate3d(0, 0, 0) scale3d(1.2, 1.2, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                      transform:
                        "translate3d(0, 0, 0) scale3d(1.2, 1.2, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)"
                    }}
                    sizes="(max-width: 1080px) 100vw, 1080px"
                    alt=""
                    srcSet="images/WhatsApp-Image-2025-10-01-at-6.15.44-PM-p-500.jpeg 500w, images/WhatsApp-Image-2025-10-01-at-6.15.44-PM-p-800.jpeg 800w, images/WhatsApp-Image-2025-10-01-at-6.15.44-PM.jpeg 1080w"
                    className="image-fill"
                  />
                  <div
                    style={{
                      display: "block",
                      WebkitTransform:
                        "translate3d(0, 0%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                      MozTransform:
                        "translate3d(0, 0%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                      msTransform:
                        "translate3d(0, 0%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                      transform:
                        "translate3d(0, 0%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)"
                    }}
                    className="image-overlay"
                  />
                </div>
                <div className="wood-component-content">
                  <div className="divider-line" />
                  <div className="wood-component-title">
                    <h4>05. rate your experience</h4>
                    <a href="#" className="wood-component-link w-inline-block">
                      <div className="wood-component-icon">
                        <div className="wood-component-icon_arrow w-embed">
                          <svg
                            version="1.1"
                            id="Ebene_1"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlnsXlink="http://www.w3.org/1999/xlink"
                            x="0px"
                            y="0px"
                            width="100%"
                            height="100%"
                            viewBox="0 0 14 14"
                            style={{ enableBackground: "new 0 0 14 14" }}
                            xmlSpace="preserve"
                          >
                            <style
                              type="text/css"
                              dangerouslySetInnerHTML={{
                                __html:
                                  "\t.st0{fill:none;stroke:currentcolor;stroke-width:1.25;stroke-linecap:square;stroke-linejoin:round;}\t.st1{fill:none;stroke:currentcolor;stroke-width:1.25;stroke-linecap:square;}"
                              }}
                            />
                            <path className="st0" d="M1.5,7H12" />
                            <path
                              className="st1"
                              d="M8.8,2.9L12.8,7l-4.1,4.1"
                            />
                          </svg>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div className="wood-component-text">
                    <div>
                      Share your thoughts and help us make every table even
                      better.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div
    data-w-id="2e391df3-0fd3-01dc-1d87-2e89689e82db"
    style={{ width: 0 }}
    className="divider-line"
  />
</section>
<>
  <section className="section case-study">
    <div className="padding-global">
      <div className="container-large">
        <div className="padding-vertical">
          <div className="w-layout-grid grid is-casestudy">
            <div
              id="w-node-_17502089-a26e-8b00-c23d-03081f42b3af-656a3cad"
              className="section-title _0-gap"
            >
              <div className="overflow-hidden">
                <h2
                  data-w-id="17502089-a26e-8b00-c23d-03081f42b3b1"
                  style={{
                    WebkitTransform:
                      "translate3d(0, 105%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                    MozTransform:
                      "translate3d(0, 105%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                    msTransform:
                      "translate3d(0, 105%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                    transform:
                      "translate3d(0, 105%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)"
                  }}
                >
                  Unforgettable
                  <br />
                </h2>
              </div>
              <div className="overflow-hidden">
                <h2
                  data-w-id="17502089-a26e-8b00-c23d-03081f42b3b5"
                  style={{
                    WebkitTransform:
                      "translate3d(0, 105%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                    MozTransform:
                      "translate3d(0, 105%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                    msTransform:
                      "translate3d(0, 105%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                    transform:
                      "translate3d(0, 105%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)"
                  }}
                >
                  <strong>
                    <em>Encounters await</em>
                  </strong>
                </h2>
              </div>
            </div>
            <div
              id="w-node-_97449641-c5ba-9793-ad4c-37e3d01856e2-656a3cad"
              className="column casestudy-intro"
            >
              <div>
                Hightable brings 4–10 people together for shared meals, real
                conversations, and moments that stay with you. We take care of
                everything you just show up.
              </div>
              <a href="https://stage-dashboard.hightable.ai" className="button-2 w-button">
                Book Your Seat
              </a>
            </div>
          </div>
          <div className="w-layout-grid grid is-casestudy">
            <div
              id="w-node-bfdfcfa3-a944-d8fe-25a8-ac66d46d23f1-656a3cad"
              data-w-id="bfdfcfa3-a944-d8fe-25a8-ac66d46d23f1"
              className="image-wrapper"
            >
              <img
                src="images/WhatsApp-Image-2025-10-01-at-6.15.45-PM-1.jpeg"
                loading="lazy"
                style={{
                  WebkitTransform:
                    "translate3d(0, 0, 0) scale3d(1.2, 1.2, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                  MozTransform:
                    "translate3d(0, 0, 0) scale3d(1.2, 1.2, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                  msTransform:
                    "translate3d(0, 0, 0) scale3d(1.2, 1.2, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                  transform:
                    "translate3d(0, 0, 0) scale3d(1.2, 1.2, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)"
                }}
                sizes="(max-width: 1080px) 100vw, 1080px"
                alt=""
                srcSet="images/WhatsApp-Image-2025-10-01-at-6.15.45-PM-1-p-500.jpeg 500w, images/WhatsApp-Image-2025-10-01-at-6.15.45-PM-1-p-800.jpeg 800w, images/WhatsApp-Image-2025-10-01-at-6.15.45-PM-1.jpeg 1080w"
                className="image-fill"
              />
              <div
                style={{
                  display: "block",
                  WebkitTransform:
                    "translate3d(0, 0%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                  MozTransform:
                    "translate3d(0, 0%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                  msTransform:
                    "translate3d(0, 0%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                  transform:
                    "translate3d(0, 0%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)"
                }}
                className="image-overlay"
              />
            </div>
            <div
              id="w-node-_367151bc-bc6d-3153-e0e8-f97a134663dd-656a3cad"
              data-w-id="367151bc-bc6d-3153-e0e8-f97a134663dd"
              className="image-wrapper"
            >
              <img
                src="images/WhatsApp-Image-2025-10-01-at-6.15.42-PM-1.jpeg"
                loading="lazy"
                style={{
                  WebkitTransform:
                    "translate3d(0, 0, 0) scale3d(1.2, 1.2, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                  MozTransform:
                    "translate3d(0, 0, 0) scale3d(1.2, 1.2, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                  msTransform:
                    "translate3d(0, 0, 0) scale3d(1.2, 1.2, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                  transform:
                    "translate3d(0, 0, 0) scale3d(1.2, 1.2, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)"
                }}
                sizes="100vw"
                alt=""
                srcSet="images/WhatsApp-Image-2025-10-01-at-6.15.42-PM-1-p-500.jpeg 500w, images/WhatsApp-Image-2025-10-01-at-6.15.42-PM-1-p-800.jpeg 800w, images/WhatsApp-Image-2025-10-01-at-6.15.42-PM-1.jpeg 1066w"
                className="image-fill"
              />
              <div
                style={{
                  display: "block",
                  WebkitTransform:
                    "translate3d(0, 0%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                  MozTransform:
                    "translate3d(0, 0%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                  msTransform:
                    "translate3d(0, 0%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                  transform:
                    "translate3d(0, 0%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)"
                }}
                className="image-overlay"
              />
            </div>
            <div
              id="w-node-_84c60382-c8e5-1138-969e-6aaf2f790c45-656a3cad"
              data-w-id="84c60382-c8e5-1138-969e-6aaf2f790c45"
              className="image-wrapper"
            >
              <img
                src="images/WhatsApp-Image-2025-10-01-at-6.15.45-PM-2.jpeg"
                loading="lazy"
                style={{
                  WebkitTransform:
                    "translate3d(0, 0, 0) scale3d(1.2, 1.2, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                  MozTransform:
                    "translate3d(0, 0, 0) scale3d(1.2, 1.2, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                  msTransform:
                    "translate3d(0, 0, 0) scale3d(1.2, 1.2, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                  transform:
                    "translate3d(0, 0, 0) scale3d(1.2, 1.2, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)"
                }}
                sizes="(max-width: 1080px) 100vw, 1080px"
                alt=""
                srcSet="images/WhatsApp-Image-2025-10-01-at-6.15.45-PM-2-p-500.jpeg 500w, images/WhatsApp-Image-2025-10-01-at-6.15.45-PM-2-p-800.jpeg 800w, images/WhatsApp-Image-2025-10-01-at-6.15.45-PM-2.jpeg 1080w"
                className="image-fill"
              />
              <div
                style={{
                  display: "block",
                  WebkitTransform:
                    "translate3d(0, 0%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                  MozTransform:
                    "translate3d(0, 0%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                  msTransform:
                    "translate3d(0, 0%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                  transform:
                    "translate3d(0, 0%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)"
                }}
                className="image-overlay"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <div className="section_reviews">
    <div className="padding-global-2">
      <div className="container-large-2">
        <div className="review-component">
          <div className="left-content">
            <div className="star-container">
              <div className="star-wrapper">
                <div className="icon w-embed">
                  <svg
                    width={420}
                    height={420}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12.0002 17L6.12223 20.59L7.72023 13.89L2.49023 9.41L9.35523 8.86L12.0002 2.5L14.6452 8.86L21.5112 9.41L16.2802 13.89L17.8782 20.59L12.0002 17Z"
                      fill="currentColor"
                    />
                  </svg>
                </div>
              </div>
              <div className="star-wrapper">
                <div className="icon w-embed">
                  <svg
                    width={420}
                    height={420}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12.0002 17L6.12223 20.59L7.72023 13.89L2.49023 9.41L9.35523 8.86L12.0002 2.5L14.6452 8.86L21.5112 9.41L16.2802 13.89L17.8782 20.59L12.0002 17Z"
                      fill="currentColor"
                    />
                  </svg>
                </div>
              </div>
              <div className="star-wrapper">
                <div className="icon w-embed">
                  <svg
                    width={420}
                    height={420}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12.0002 17L6.12223 20.59L7.72023 13.89L2.49023 9.41L9.35523 8.86L12.0002 2.5L14.6452 8.86L21.5112 9.41L16.2802 13.89L17.8782 20.59L12.0002 17Z"
                      fill="currentColor"
                    />
                  </svg>
                </div>
              </div>
              <div className="star-wrapper">
                <div className="icon w-embed">
                  <svg
                    width={420}
                    height={420}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12.0002 17L6.12223 20.59L7.72023 13.89L2.49023 9.41L9.35523 8.86L12.0002 2.5L14.6452 8.86L21.5112 9.41L16.2802 13.89L17.8782 20.59L12.0002 17Z"
                      fill="currentColor"
                    />
                  </svg>
                </div>
              </div>
              <div className="star-wrapper">
                <div className="icon w-embed">
                  <svg
                    width={420}
                    height={420}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12.0002 17L6.12223 20.59L7.72023 13.89L2.49023 9.41L9.35523 8.86L12.0002 2.5L14.6452 8.86L21.5112 9.41L16.2802 13.89L17.8782 20.59L12.0002 17Z"
                      fill="currentColor"
                    />
                  </svg>
                </div>
              </div>
            </div>
            <div className="margin-bottom-2 margin-medium">
              <div className="section-title _0-gap">
                <div className="overflow-hidden">
                  <h2
                    data-w-id="49d0fa5f-42c4-4455-d84f-6d1345cda709"
                    style={{
                      WebkitTransform:
                        "translate3d(0, 105%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                      MozTransform:
                        "translate3d(0, 105%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                      msTransform:
                        "translate3d(0, 105%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                      transform:
                        "translate3d(0, 105%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)"
                    }}
                    className="white"
                  >
                    What people say about
                    <br />
                  </h2>
                </div>
                <div className="overflow-hidden">
                  <h2
                    data-w-id="49d0fa5f-42c4-4455-d84f-6d1345cda70d"
                    style={{
                      WebkitTransform:
                        "translate3d(0, 105%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                      MozTransform:
                        "translate3d(0, 105%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                      msTransform:
                        "translate3d(0, 105%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                      transform:
                        "translate3d(0, 105%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)"
                    }}
                  >
                    <strong>
                      <em className="white">Hightable</em>
                    </strong>
                  </h2>
                </div>
              </div>
            </div>
            <div className="margin-bottom-2 margin-medium">
              <p className="paragraph white">
                Demo Content that goes here as sub text under reviews
              </p>
            </div>
          </div>
          <div
            data-w-id="1773a02e-4b25-3e30-8007-41752ddc1a4a"
            style={{ opacity: 0 }}
            className="reviews-wrapper"
          >
            <div className="right-reviews-container">
              <div className="scroll">
                <div className="collection-list-wrapper">
                  <div className="collection-list">
                    <div className="review-item">
                      <p className="review-text">
                        The best part about HighTable? Definitely the host. From
                        the very first moment, you feel genuinely seen and
                        welcomed, as if you’re meeting an old friend rather than
                        stepping into a new space. There’s an effortless way the
                        host creates comfort, sets the tone, and makes sure
                        everyone feels included. That presence turns what could
                        just be another gathering into something
                        meaningful—where connections feel natural and
                        conversations flow with ease.
                      </p>
                      <div className="reviewer-profile-wrapper">
                        <div className="star-container">
                          <div className="star-wrapper">
                            <div className="review-star w-embed">
                              <svg
                                width={420}
                                height={420}
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M12.0002 17L6.12223 20.59L7.72023 13.89L2.49023 9.41L9.35523 8.86L12.0002 2.5L14.6452 8.86L21.5112 9.41L16.2802 13.89L17.8782 20.59L12.0002 17Z"
                                  fill="currentColor"
                                />
                              </svg>
                            </div>
                          </div>
                          <div className="star-wrapper">
                            <div className="review-star w-embed">
                              <svg
                                width={420}
                                height={420}
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M12.0002 17L6.12223 20.59L7.72023 13.89L2.49023 9.41L9.35523 8.86L12.0002 2.5L14.6452 8.86L21.5112 9.41L16.2802 13.89L17.8782 20.59L12.0002 17Z"
                                  fill="currentColor"
                                />
                              </svg>
                            </div>
                          </div>
                          <div className="star-wrapper">
                            <div className="review-star w-embed">
                              <svg
                                width={420}
                                height={420}
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M12.0002 17L6.12223 20.59L7.72023 13.89L2.49023 9.41L9.35523 8.86L12.0002 2.5L14.6452 8.86L21.5112 9.41L16.2802 13.89L17.8782 20.59L12.0002 17Z"
                                  fill="currentColor"
                                />
                              </svg>
                            </div>
                          </div>
                          <div className="star-wrapper">
                            <div className="review-star w-embed">
                              <svg
                                width={420}
                                height={420}
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M12.0002 17L6.12223 20.59L7.72023 13.89L2.49023 9.41L9.35523 8.86L12.0002 2.5L14.6452 8.86L21.5112 9.41L16.2802 13.89L17.8782 20.59L12.0002 17Z"
                                  fill="currentColor"
                                />
                              </svg>
                            </div>
                          </div>
                          <div className="star-wrapper">
                            <div className="review-star w-embed">
                              <svg
                                width={420}
                                height={420}
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M12.0002 17L6.12223 20.59L7.72023 13.89L2.49023 9.41L9.35523 8.86L12.0002 2.5L14.6452 8.86L21.5112 9.41L16.2802 13.89L17.8782 20.59L12.0002 17Z"
                                  fill="currentColor"
                                />
                              </svg>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="review-item">
                      <p className="review-text">
                        I signed up for the Girl Talk Chronicles table, but
                        almost didn't show up. I was standing outside the café
                        for 10 minutes, overthinking everything - what if no one
                        talks to me, what if I don't fit in? But the moment I
                        walked in, someone waved me over like I already
                        belonged. We ended up talking about everything from exes
                        to skincare to our dream cities. I hadn't laughed like
                        that in a while. Thank you for creating a space where
                        it's this easy to connect!
                        <br />
                        <br />I can't wait to attend more such tables:')
                      </p>
                      <div className="reviewer-profile-wrapper">
                        <div className="star-container">
                          <div className="star-wrapper">
                            <div className="review-star w-embed">
                              <svg
                                width={420}
                                height={420}
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M12.0002 17L6.12223 20.59L7.72023 13.89L2.49023 9.41L9.35523 8.86L12.0002 2.5L14.6452 8.86L21.5112 9.41L16.2802 13.89L17.8782 20.59L12.0002 17Z"
                                  fill="currentColor"
                                />
                              </svg>
                            </div>
                          </div>
                          <div className="star-wrapper">
                            <div className="review-star w-embed">
                              <svg
                                width={420}
                                height={420}
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M12.0002 17L6.12223 20.59L7.72023 13.89L2.49023 9.41L9.35523 8.86L12.0002 2.5L14.6452 8.86L21.5112 9.41L16.2802 13.89L17.8782 20.59L12.0002 17Z"
                                  fill="currentColor"
                                />
                              </svg>
                            </div>
                          </div>
                          <div className="star-wrapper">
                            <div className="review-star w-embed">
                              <svg
                                width={420}
                                height={420}
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M12.0002 17L6.12223 20.59L7.72023 13.89L2.49023 9.41L9.35523 8.86L12.0002 2.5L14.6452 8.86L21.5112 9.41L16.2802 13.89L17.8782 20.59L12.0002 17Z"
                                  fill="currentColor"
                                />
                              </svg>
                            </div>
                          </div>
                          <div className="star-wrapper">
                            <div className="review-star w-embed">
                              <svg
                                width={420}
                                height={420}
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M12.0002 17L6.12223 20.59L7.72023 13.89L2.49023 9.41L9.35523 8.86L12.0002 2.5L14.6452 8.86L21.5112 9.41L16.2802 13.89L17.8782 20.59L12.0002 17Z"
                                  fill="currentColor"
                                />
                              </svg>
                            </div>
                          </div>
                          <div className="star-wrapper">
                            <div className="review-star w-embed">
                              <svg
                                width={420}
                                height={420}
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M12.0002 17L6.12223 20.59L7.72023 13.89L2.49023 9.41L9.35523 8.86L12.0002 2.5L14.6452 8.86L21.5112 9.41L16.2802 13.89L17.8782 20.59L12.0002 17Z"
                                  fill="currentColor"
                                />
                              </svg>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="review-item">
                      <p className="review-text">
                        My first table was amazing-great people, a cozy
                        atmosphere, and easy conversations. I left feeling
                        inspired, refreshed, and truly connected. A must for
                        anyone seeking meaningful dialogue. If you're new to
                        bir, trust me, this is what you NEED!
                      </p>
                      <div className="reviewer-profile-wrapper">
                        <div className="star-container">
                          <div className="star-wrapper">
                            <div className="review-star w-embed">
                              <svg
                                width={420}
                                height={420}
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M12.0002 17L6.12223 20.59L7.72023 13.89L2.49023 9.41L9.35523 8.86L12.0002 2.5L14.6452 8.86L21.5112 9.41L16.2802 13.89L17.8782 20.59L12.0002 17Z"
                                  fill="currentColor"
                                />
                              </svg>
                            </div>
                          </div>
                          <div className="star-wrapper">
                            <div className="review-star w-embed">
                              <svg
                                width={420}
                                height={420}
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M12.0002 17L6.12223 20.59L7.72023 13.89L2.49023 9.41L9.35523 8.86L12.0002 2.5L14.6452 8.86L21.5112 9.41L16.2802 13.89L17.8782 20.59L12.0002 17Z"
                                  fill="currentColor"
                                />
                              </svg>
                            </div>
                          </div>
                          <div className="star-wrapper">
                            <div className="review-star w-embed">
                              <svg
                                width={420}
                                height={420}
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M12.0002 17L6.12223 20.59L7.72023 13.89L2.49023 9.41L9.35523 8.86L12.0002 2.5L14.6452 8.86L21.5112 9.41L16.2802 13.89L17.8782 20.59L12.0002 17Z"
                                  fill="currentColor"
                                />
                              </svg>
                            </div>
                          </div>
                          <div className="star-wrapper">
                            <div className="review-star w-embed">
                              <svg
                                width={420}
                                height={420}
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M12.0002 17L6.12223 20.59L7.72023 13.89L2.49023 9.41L9.35523 8.86L12.0002 2.5L14.6452 8.86L21.5112 9.41L16.2802 13.89L17.8782 20.59L12.0002 17Z"
                                  fill="currentColor"
                                />
                              </svg>
                            </div>
                          </div>
                          <div className="star-wrapper">
                            <div className="review-star w-embed">
                              <svg
                                width={420}
                                height={420}
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M12.0002 17L6.12223 20.59L7.72023 13.89L2.49023 9.41L9.35523 8.86L12.0002 2.5L14.6452 8.86L21.5112 9.41L16.2802 13.89L17.8782 20.59L12.0002 17Z"
                                  fill="currentColor"
                                />
                              </svg>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="review-item">
                      <p className="review-text">
                        HighTable taught me that while it's easy to stay in our
                        comfort zones with familiar friends, growth happens when
                        we sit with strangers and hear differing ideologies-even
                        jarring ones. In a polarized world, we need spaces to
                        'agree to disagree amicably.' What I cherish most is the
                        synergy in our collective experience as women: open,
                        vulnerable, and free from worrying about 'how we're
                        dressed or who's looking.' It's liberating to just be.
                        I'll always hold a soft corner for women-only circles,
                        but I'm eager for more tables-mixed or not-where
                        curiosity bridges divides.
                      </p>
                      <div className="reviewer-profile-wrapper">
                        <div className="star-container">
                          <div className="star-wrapper">
                            <div className="review-star w-embed">
                              <svg
                                width={420}
                                height={420}
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M12.0002 17L6.12223 20.59L7.72023 13.89L2.49023 9.41L9.35523 8.86L12.0002 2.5L14.6452 8.86L21.5112 9.41L16.2802 13.89L17.8782 20.59L12.0002 17Z"
                                  fill="currentColor"
                                />
                              </svg>
                            </div>
                          </div>
                          <div className="star-wrapper">
                            <div className="review-star w-embed">
                              <svg
                                width={420}
                                height={420}
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M12.0002 17L6.12223 20.59L7.72023 13.89L2.49023 9.41L9.35523 8.86L12.0002 2.5L14.6452 8.86L21.5112 9.41L16.2802 13.89L17.8782 20.59L12.0002 17Z"
                                  fill="currentColor"
                                />
                              </svg>
                            </div>
                          </div>
                          <div className="star-wrapper">
                            <div className="review-star w-embed">
                              <svg
                                width={420}
                                height={420}
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M12.0002 17L6.12223 20.59L7.72023 13.89L2.49023 9.41L9.35523 8.86L12.0002 2.5L14.6452 8.86L21.5112 9.41L16.2802 13.89L17.8782 20.59L12.0002 17Z"
                                  fill="currentColor"
                                />
                              </svg>
                            </div>
                          </div>
                          <div className="star-wrapper">
                            <div className="review-star w-embed">
                              <svg
                                width={420}
                                height={420}
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M12.0002 17L6.12223 20.59L7.72023 13.89L2.49023 9.41L9.35523 8.86L12.0002 2.5L14.6452 8.86L21.5112 9.41L16.2802 13.89L17.8782 20.59L12.0002 17Z"
                                  fill="currentColor"
                                />
                              </svg>
                            </div>
                          </div>
                          <div className="star-wrapper">
                            <div className="review-star w-embed">
                              <svg
                                width={420}
                                height={420}
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M12.0002 17L6.12223 20.59L7.72023 13.89L2.49023 9.41L9.35523 8.86L12.0002 2.5L14.6452 8.86L21.5112 9.41L16.2802 13.89L17.8782 20.59L12.0002 17Z"
                                  fill="currentColor"
                                />
                              </svg>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="review-item">
                      <p className="review-text">
                        HighTable isn’t just a place to meet people—it’s a place
                        to truly connect. The atmosphere feels warm and
                        inviting, and the conversations are always genuine. You
                        leave feeling like you’ve met kindred spirits rather
                        than just strangers.
                      </p>
                      <div className="reviewer-profile-wrapper">
                        <div className="star-container">
                          <div className="star-wrapper">
                            <div className="review-star w-embed">
                              <svg
                                width={420}
                                height={420}
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M12.0002 17L6.12223 20.59L7.72023 13.89L2.49023 9.41L9.35523 8.86L12.0002 2.5L14.6452 8.86L21.5112 9.41L16.2802 13.89L17.8782 20.59L12.0002 17Z"
                                  fill="currentColor"
                                />
                              </svg>
                            </div>
                          </div>
                          <div className="star-wrapper">
                            <div className="review-star w-embed">
                              <svg
                                width={420}
                                height={420}
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M12.0002 17L6.12223 20.59L7.72023 13.89L2.49023 9.41L9.35523 8.86L12.0002 2.5L14.6452 8.86L21.5112 9.41L16.2802 13.89L17.8782 20.59L12.0002 17Z"
                                  fill="currentColor"
                                />
                              </svg>
                            </div>
                          </div>
                          <div className="star-wrapper">
                            <div className="review-star w-embed">
                              <svg
                                width={420}
                                height={420}
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M12.0002 17L6.12223 20.59L7.72023 13.89L2.49023 9.41L9.35523 8.86L12.0002 2.5L14.6452 8.86L21.5112 9.41L16.2802 13.89L17.8782 20.59L12.0002 17Z"
                                  fill="currentColor"
                                />
                              </svg>
                            </div>
                          </div>
                          <div className="star-wrapper">
                            <div className="review-star w-embed">
                              <svg
                                width={420}
                                height={420}
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M12.0002 17L6.12223 20.59L7.72023 13.89L2.49023 9.41L9.35523 8.86L12.0002 2.5L14.6452 8.86L21.5112 9.41L16.2802 13.89L17.8782 20.59L12.0002 17Z"
                                  fill="currentColor"
                                />
                              </svg>
                            </div>
                          </div>
                          <div className="star-wrapper">
                            <div className="review-star w-embed">
                              <svg
                                width={420}
                                height={420}
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M12.0002 17L6.12223 20.59L7.72023 13.89L2.49023 9.41L9.35523 8.86L12.0002 2.5L14.6452 8.86L21.5112 9.41L16.2802 13.89L17.8782 20.59L12.0002 17Z"
                                  fill="currentColor"
                                />
                              </svg>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="review-item">
                      <p className="review-text">
                        I’ve attended many events, but HighTable feels
                        different. You’re not just part of a crowd—you’re part
                        of a community. The host has a way of making everyone
                        feel included and valued, which makes the entire evening
                        feel meaningful and memorable.
                      </p>
                      <div className="reviewer-profile-wrapper">
                        <div className="star-container">
                          <div className="star-wrapper">
                            <div className="review-star w-embed">
                              <svg
                                width={420}
                                height={420}
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M12.0002 17L6.12223 20.59L7.72023 13.89L2.49023 9.41L9.35523 8.86L12.0002 2.5L14.6452 8.86L21.5112 9.41L16.2802 13.89L17.8782 20.59L12.0002 17Z"
                                  fill="currentColor"
                                />
                              </svg>
                            </div>
                          </div>
                          <div className="star-wrapper">
                            <div className="review-star w-embed">
                              <svg
                                width={420}
                                height={420}
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M12.0002 17L6.12223 20.59L7.72023 13.89L2.49023 9.41L9.35523 8.86L12.0002 2.5L14.6452 8.86L21.5112 9.41L16.2802 13.89L17.8782 20.59L12.0002 17Z"
                                  fill="currentColor"
                                />
                              </svg>
                            </div>
                          </div>
                          <div className="star-wrapper">
                            <div className="review-star w-embed">
                              <svg
                                width={420}
                                height={420}
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M12.0002 17L6.12223 20.59L7.72023 13.89L2.49023 9.41L9.35523 8.86L12.0002 2.5L14.6452 8.86L21.5112 9.41L16.2802 13.89L17.8782 20.59L12.0002 17Z"
                                  fill="currentColor"
                                />
                              </svg>
                            </div>
                          </div>
                          <div className="star-wrapper">
                            <div className="review-star w-embed">
                              <svg
                                width={420}
                                height={420}
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M12.0002 17L6.12223 20.59L7.72023 13.89L2.49023 9.41L9.35523 8.86L12.0002 2.5L14.6452 8.86L21.5112 9.41L16.2802 13.89L17.8782 20.59L12.0002 17Z"
                                  fill="currentColor"
                                />
                              </svg>
                            </div>
                          </div>
                          <div className="star-wrapper">
                            <div className="review-star w-embed">
                              <svg
                                width={420}
                                height={420}
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M12.0002 17L6.12223 20.59L7.72023 13.89L2.49023 9.41L9.35523 8.86L12.0002 2.5L14.6452 8.86L21.5112 9.41L16.2802 13.89L17.8782 20.59L12.0002 17Z"
                                  fill="currentColor"
                                />
                              </svg>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="left-reviews-container">
              <div className="reverse scroll">
                <div className="collection-list-wrapper">
                  <div className="collection-list">
                    <div className="review-item">
                      <p className="review-text">
                        What I love about Hightable is how inclusive it feels.
                        You don’t have to be a founder or CXO to belong here.
                        Everyone has a seat at the table, and that makes all the
                        difference.
                      </p>
                      <div className="reviewer-profile-wrapper">
                        <div className="reviewer">
                          Arvind Krishnan, Law Student
                        </div>
                        <div className="star-container">
                          <div className="star-wrapper">
                            <div className="review-star w-embed">
                              <svg
                                width={420}
                                height={420}
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M12.0002 17L6.12223 20.59L7.72023 13.89L2.49023 9.41L9.35523 8.86L12.0002 2.5L14.6452 8.86L21.5112 9.41L16.2802 13.89L17.8782 20.59L12.0002 17Z"
                                  fill="currentColor"
                                />
                              </svg>
                            </div>
                          </div>
                          <div className="star-wrapper">
                            <div className="review-star w-embed">
                              <svg
                                width={420}
                                height={420}
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M12.0002 17L6.12223 20.59L7.72023 13.89L2.49023 9.41L9.35523 8.86L12.0002 2.5L14.6452 8.86L21.5112 9.41L16.2802 13.89L17.8782 20.59L12.0002 17Z"
                                  fill="currentColor"
                                />
                              </svg>
                            </div>
                          </div>
                          <div className="star-wrapper">
                            <div className="review-star w-embed">
                              <svg
                                width={420}
                                height={420}
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M12.0002 17L6.12223 20.59L7.72023 13.89L2.49023 9.41L9.35523 8.86L12.0002 2.5L14.6452 8.86L21.5112 9.41L16.2802 13.89L17.8782 20.59L12.0002 17Z"
                                  fill="currentColor"
                                />
                              </svg>
                            </div>
                          </div>
                          <div className="star-wrapper">
                            <div className="review-star w-embed">
                              <svg
                                width={420}
                                height={420}
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M12.0002 17L6.12223 20.59L7.72023 13.89L2.49023 9.41L9.35523 8.86L12.0002 2.5L14.6452 8.86L21.5112 9.41L16.2802 13.89L17.8782 20.59L12.0002 17Z"
                                  fill="currentColor"
                                />
                              </svg>
                            </div>
                          </div>
                          <div className="star-wrapper">
                            <div className="review-star w-embed">
                              <svg
                                width={420}
                                height={420}
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M12.0002 17L6.12223 20.59L7.72023 13.89L2.49023 9.41L9.35523 8.86L12.0002 2.5L14.6452 8.86L21.5112 9.41L16.2802 13.89L17.8782 20.59L12.0002 17Z"
                                  fill="currentColor"
                                />
                              </svg>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="review-item">
                      <p className="review-text">
                        The beauty of Hightable is how effortless it makes
                        offline connections. I walked into my first event not
                        knowing anyone and walked out with three solid
                        collaborations. That’s powerful.
                      </p>
                      <div className="reviewer-profile-wrapper">
                        <div className="reviewer">
                          Rohan Mehta, Entrepreneur
                        </div>
                        <div className="star-container">
                          <div className="star-wrapper">
                            <div className="review-star w-embed">
                              <svg
                                width={420}
                                height={420}
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M12.0002 17L6.12223 20.59L7.72023 13.89L2.49023 9.41L9.35523 8.86L12.0002 2.5L14.6452 8.86L21.5112 9.41L16.2802 13.89L17.8782 20.59L12.0002 17Z"
                                  fill="currentColor"
                                />
                              </svg>
                            </div>
                          </div>
                          <div className="star-wrapper">
                            <div className="review-star w-embed">
                              <svg
                                width={420}
                                height={420}
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M12.0002 17L6.12223 20.59L7.72023 13.89L2.49023 9.41L9.35523 8.86L12.0002 2.5L14.6452 8.86L21.5112 9.41L16.2802 13.89L17.8782 20.59L12.0002 17Z"
                                  fill="currentColor"
                                />
                              </svg>
                            </div>
                          </div>
                          <div className="star-wrapper">
                            <div className="review-star w-embed">
                              <svg
                                width={420}
                                height={420}
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M12.0002 17L6.12223 20.59L7.72023 13.89L2.49023 9.41L9.35523 8.86L12.0002 2.5L14.6452 8.86L21.5112 9.41L16.2802 13.89L17.8782 20.59L12.0002 17Z"
                                  fill="currentColor"
                                />
                              </svg>
                            </div>
                          </div>
                          <div className="star-wrapper">
                            <div className="review-star w-embed">
                              <svg
                                width={420}
                                height={420}
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M12.0002 17L6.12223 20.59L7.72023 13.89L2.49023 9.41L9.35523 8.86L12.0002 2.5L14.6452 8.86L21.5112 9.41L16.2802 13.89L17.8782 20.59L12.0002 17Z"
                                  fill="currentColor"
                                />
                              </svg>
                            </div>
                          </div>
                          <div className="star-wrapper">
                            <div className="review-star w-embed">
                              <svg
                                width={420}
                                height={420}
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M12.0002 17L6.12223 20.59L7.72023 13.89L2.49023 9.41L9.35523 8.86L12.0002 2.5L14.6452 8.86L21.5112 9.41L16.2802 13.89L17.8782 20.59L12.0002 17Z"
                                  fill="currentColor"
                                />
                              </svg>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="review-item">
                      <p className="review-text">
                        Unlike most platforms that feel transactional, Hightable
                        feels authentic. You meet people, not profiles.
                      </p>
                      <div className="reviewer-profile-wrapper">
                        <div className="reviewer">
                          Maya Iyer, Wellness Coach
                        </div>
                        <div className="star-container">
                          <div className="star-wrapper">
                            <div className="review-star w-embed">
                              <svg
                                width={420}
                                height={420}
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M12.0002 17L6.12223 20.59L7.72023 13.89L2.49023 9.41L9.35523 8.86L12.0002 2.5L14.6452 8.86L21.5112 9.41L16.2802 13.89L17.8782 20.59L12.0002 17Z"
                                  fill="currentColor"
                                />
                              </svg>
                            </div>
                          </div>
                          <div className="star-wrapper">
                            <div className="review-star w-embed">
                              <svg
                                width={420}
                                height={420}
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M12.0002 17L6.12223 20.59L7.72023 13.89L2.49023 9.41L9.35523 8.86L12.0002 2.5L14.6452 8.86L21.5112 9.41L16.2802 13.89L17.8782 20.59L12.0002 17Z"
                                  fill="currentColor"
                                />
                              </svg>
                            </div>
                          </div>
                          <div className="star-wrapper">
                            <div className="review-star w-embed">
                              <svg
                                width={420}
                                height={420}
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M12.0002 17L6.12223 20.59L7.72023 13.89L2.49023 9.41L9.35523 8.86L12.0002 2.5L14.6452 8.86L21.5112 9.41L16.2802 13.89L17.8782 20.59L12.0002 17Z"
                                  fill="currentColor"
                                />
                              </svg>
                            </div>
                          </div>
                          <div className="star-wrapper">
                            <div className="review-star w-embed">
                              <svg
                                width={420}
                                height={420}
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M12.0002 17L6.12223 20.59L7.72023 13.89L2.49023 9.41L9.35523 8.86L12.0002 2.5L14.6452 8.86L21.5112 9.41L16.2802 13.89L17.8782 20.59L12.0002 17Z"
                                  fill="currentColor"
                                />
                              </svg>
                            </div>
                          </div>
                          <div className="star-wrapper">
                            <div className="review-star w-embed">
                              <svg
                                width={420}
                                height={420}
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M12.0002 17L6.12223 20.59L7.72023 13.89L2.49023 9.41L9.35523 8.86L12.0002 2.5L14.6452 8.86L21.5112 9.41L16.2802 13.89L17.8782 20.59L12.0002 17Z"
                                  fill="currentColor"
                                />
                              </svg>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="review-item">
                      <p className="review-text">
                        I came in expecting a networking event and left with
                        friends, mentors, and even a business partner. That’s
                        the Hightable difference.
                      </p>
                      <div className="reviewer-profile-wrapper">
                        <div className="reviewer">Abhishek Nair</div>
                        <div className="star-container">
                          <div className="star-wrapper">
                            <div className="review-star w-embed">
                              <svg
                                width={420}
                                height={420}
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M12.0002 17L6.12223 20.59L7.72023 13.89L2.49023 9.41L9.35523 8.86L12.0002 2.5L14.6452 8.86L21.5112 9.41L16.2802 13.89L17.8782 20.59L12.0002 17Z"
                                  fill="currentColor"
                                />
                              </svg>
                            </div>
                          </div>
                          <div className="star-wrapper">
                            <div className="review-star w-embed">
                              <svg
                                width={420}
                                height={420}
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M12.0002 17L6.12223 20.59L7.72023 13.89L2.49023 9.41L9.35523 8.86L12.0002 2.5L14.6452 8.86L21.5112 9.41L16.2802 13.89L17.8782 20.59L12.0002 17Z"
                                  fill="currentColor"
                                />
                              </svg>
                            </div>
                          </div>
                          <div className="star-wrapper">
                            <div className="review-star w-embed">
                              <svg
                                width={420}
                                height={420}
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M12.0002 17L6.12223 20.59L7.72023 13.89L2.49023 9.41L9.35523 8.86L12.0002 2.5L14.6452 8.86L21.5112 9.41L16.2802 13.89L17.8782 20.59L12.0002 17Z"
                                  fill="currentColor"
                                />
                              </svg>
                            </div>
                          </div>
                          <div className="star-wrapper">
                            <div className="review-star w-embed">
                              <svg
                                width={420}
                                height={420}
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M12.0002 17L6.12223 20.59L7.72023 13.89L2.49023 9.41L9.35523 8.86L12.0002 2.5L14.6452 8.86L21.5112 9.41L16.2802 13.89L17.8782 20.59L12.0002 17Z"
                                  fill="currentColor"
                                />
                              </svg>
                            </div>
                          </div>
                          <div className="star-wrapper">
                            <div className="review-star w-embed">
                              <svg
                                width={420}
                                height={420}
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M12.0002 17L6.12223 20.59L7.72023 13.89L2.49023 9.41L9.35523 8.86L12.0002 2.5L14.6452 8.86L21.5112 9.41L16.2802 13.89L17.8782 20.59L12.0002 17Z"
                                  fill="currentColor"
                                />
                              </svg>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="review-item">
                      <p className="review-text">
                        What sets HighTable apart is the attention to detail and
                        the thoughtfulness of the host. Every interaction feels
                        personal, and there’s a sense of ease that makes it
                        effortless to open up and engage. It’s more than a
                        gathering; it’s an experience.
                      </p>
                      <div className="reviewer-profile-wrapper">
                        <div className="reviewer">Tuhin Thakur</div>
                        <div className="star-container">
                          <div className="star-wrapper">
                            <div className="review-star w-embed">
                              <svg
                                width={420}
                                height={420}
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M12.0002 17L6.12223 20.59L7.72023 13.89L2.49023 9.41L9.35523 8.86L12.0002 2.5L14.6452 8.86L21.5112 9.41L16.2802 13.89L17.8782 20.59L12.0002 17Z"
                                  fill="currentColor"
                                />
                              </svg>
                            </div>
                          </div>
                          <div className="star-wrapper">
                            <div className="review-star w-embed">
                              <svg
                                width={420}
                                height={420}
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M12.0002 17L6.12223 20.59L7.72023 13.89L2.49023 9.41L9.35523 8.86L12.0002 2.5L14.6452 8.86L21.5112 9.41L16.2802 13.89L17.8782 20.59L12.0002 17Z"
                                  fill="currentColor"
                                />
                              </svg>
                            </div>
                          </div>
                          <div className="star-wrapper">
                            <div className="review-star w-embed">
                              <svg
                                width={420}
                                height={420}
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M12.0002 17L6.12223 20.59L7.72023 13.89L2.49023 9.41L9.35523 8.86L12.0002 2.5L14.6452 8.86L21.5112 9.41L16.2802 13.89L17.8782 20.59L12.0002 17Z"
                                  fill="currentColor"
                                />
                              </svg>
                            </div>
                          </div>
                          <div className="star-wrapper">
                            <div className="review-star w-embed">
                              <svg
                                width={420}
                                height={420}
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M12.0002 17L6.12223 20.59L7.72023 13.89L2.49023 9.41L9.35523 8.86L12.0002 2.5L14.6452 8.86L21.5112 9.41L16.2802 13.89L17.8782 20.59L12.0002 17Z"
                                  fill="currentColor"
                                />
                              </svg>
                            </div>
                          </div>
                          <div className="star-wrapper">
                            <div className="review-star w-embed">
                              <svg
                                width={420}
                                height={420}
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M12.0002 17L6.12223 20.59L7.72023 13.89L2.49023 9.41L9.35523 8.86L12.0002 2.5L14.6452 8.86L21.5112 9.41L16.2802 13.89L17.8782 20.59L12.0002 17Z"
                                  fill="currentColor"
                                />
                              </svg>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="fixed-block" />
          </div>
        </div>
      </div>
    </div>
  </div>
  <section className="section is-footer">
    <div
      data-w-id="476de8ab-da1c-3cce-edcb-244201b08a74"
      style={{ width: 0 }}
      className="divider-line"
    />
    <div className="padding-global">
      <div className="container-large">
        <div className="footer-component">
          <div className="spacer-footer _5rem" />
          <div className="w-layout-grid grid is-footer watingfor">
            <h1
              data-w-id="05f2ac01-4fdf-678d-2ab3-f4b3bcbb642f"
              style={{ opacity: 0 }}
              className="dine-title"
            >
              What are you waiting{" "}
              <span className="text-span">
                <em className="italic-text">For?</em>
              </span>
            </h1>
            <div
              data-w-id="2df8dc0d-c2b9-9862-0b2f-d015ac16a338"
              style={{ opacity: 0 }}
              className="cta-btn"
            >
              <a href="/https://stage-dashboard.hightable.ai" className="button-2 home-cta w-button">
                Book Your Seat
              </a>
            </div>
          </div>
          <div className="spacer-footer _5rem" />
          <div className="w-layout-grid grid is-footer">
            <div
              id="w-node-dde939a1-2cfd-2b0e-7a58-32164561e53f-656a3cad"
              className="column footer-nav"
            >
              <a
                data-w-id="988eb3d8-aede-c0f8-956b-f1d637742e17"
                href="#"
                className="link is-footer w-inline-block"
              >
                <div>home</div>
                <div style={{ width: 0 }} className="divider-line" />
              </a>
              <a
                data-w-id="595ca243-c38f-08da-0cb0-733132d41eb4"
                href="#"
                className="link is-footer w-inline-block"
              >
                <div>about</div>
                <div style={{ width: 0 }} className="divider-line" />
              </a>
              <a
                data-w-id="f997574f-aa7a-0f52-d8ab-a56f8b411e61"
                href="#"
                className="link is-footer w-inline-block"
              >
                <div>blogs</div>
                <div style={{ width: 0 }} className="divider-line" />
              </a>
              <a
                data-w-id="ecf74407-800d-ad94-696e-b6542a7ccdcc"
                href="#"
                className="link is-footer w-inline-block"
              >
                <div>FAQ's</div>
                <div style={{ width: 0 }} className="divider-line" />
              </a>
              <a
                data-w-id="681deea3-9b91-4999-b637-2df4501bdd6b"
                href="#"
                className="link is-footer w-inline-block"
              >
                <div style={{ width: 0 }} className="divider-line" />
              </a>
            </div>
            <div
              id="w-node-ed4255df-8343-d4eb-451f-996f763938d9-656a3cad"
              className="column footer-right"
            >
              <div className="column footer-nav">
                <a
                  data-w-id="65502106-0a14-a371-4ec7-45452706ee47"
                  href="#"
                  className="link is-footer w-inline-block"
                >
                  <div>instagram</div>
                  <div style={{ width: 0 }} className="divider-line" />
                </a>
                <a
                  data-w-id="65502106-0a14-a371-4ec7-45452706ee4b"
                  href="#"
                  className="link is-footer w-inline-block"
                >
                  <div>linkedin</div>
                  <div style={{ width: 0 }} className="divider-line" />
                </a>
                <a
                  data-w-id="65502106-0a14-a371-4ec7-45452706ee4f"
                  href="#"
                  className="link is-footer w-inline-block"
                >
                  <div>Facebook</div>
                  <div style={{ width: 0 }} className="divider-line" />
                </a>
              </div>
              <a
                href="#"
                data-w-id="a3b4305a-8a90-54de-b55a-2d57c7f8737b"
                className="link is-footer w-inline-block"
              >
                <div>back to top</div>
                <div style={{ width: 0 }} className="divider-line" />
              </a>
            </div>
          </div>
          <div className="spacer-huge" />
          <div className="w-layout-grid grid is-footer black-footer">
            <div
              id="w-node-c7fe8e1d-c3ff-13b1-56f4-733cc0c687c9-656a3cad"
              className="text-size-tiny"
            >
              ©HighTable. All rights reserved.
            </div>
            <div
              id="w-node-_77422254-aa9f-865e-16e3-1bc067ae4656-656a3cad"
              className="column footer-right"
            >
              <a href="#">Privacy Policy</a>
              <a
                id="w-node-c7fe8e1d-c3ff-13b1-56f4-733cc0c687cd-656a3cad"
                href="https://www.lukas-rudrof.de"
                target="_blank"
                className="nodecor"
              >
                Designed with ♥ by Kwad
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <div className="section is-info">
    <div className="padding-global">
      <div className="container-large">
        <div className="padding-vertical padding-xhuge">
          <div className="grid is-footer black-footer">
            <div className="social-wrapper left-aligned">
              <img
                src="images/High_Table_Logo.png"
                loading="lazy"
                sizes="(max-width: 1080px) 100vw, 1080px"
                srcSet="images/High_Table_Logo-p-500.png 500w, images/High_Table_Logo-p-800.png 800w, images/High_Table_Logo.png 1080w"
                alt=""
                className="image-author"
              />
              <div className="social-author">
                <h5>Hightable</h5>
                <div>
                  HighTable is a unique social experience where 4–10 people come
                  together over a shared meal and meaningful conversation. It’s
                  a space that invites openness — where stories unfold
                  naturally, laughter finds its way in, and strangers often
                  leave as friends.
                </div>
              </div>
            </div>
            <div className="column footer-right">
              <div className="social-wrapper">
                <h5>T&amp;C</h5>
                <div className="button-group margin-top">
                  <a
                    data-w-id="786b13da-3196-a1c8-f674-c1b7d437c3d0"
                    href="https://www.lukas-rudrof.de"
                    target="_blank"
                    className="button-author is-text-link w-inline-block"
                  >
                    <div className="button-link-content">
                      <div>Terms of service</div>
                      <div className="button-arrow-wrapper">
                        <div className="icon-1x1-small-2 w-embed">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth={2}
                            stroke="currentColor"
                            className="w-6 h-6"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3"
                            />
                          </svg>
                        </div>
                        <div
                          style={{
                            WebkitTransform:
                              "translate3d(-100%, 0, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                            MozTransform:
                              "translate3d(-100%, 0, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                            msTransform:
                              "translate3d(-100%, 0, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                            transform:
                              "translate3d(-100%, 0, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)"
                          }}
                          className="icon-1x1-small-second w-embed"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth={2}
                            stroke="currentColor"
                            className="w-6 h-6"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3"
                            />
                          </svg>
                        </div>
                      </div>
                    </div>
                    <div className="button-underline">
                      <div
                        style={{ width: 0 }}
                        className="button-underline-progress"
                      />
                    </div>
                  </a>
                </div>
              </div>
              <div className="social-wrapper gaptop">
                <h5>Say Hi</h5>
                <div className="button-group margin-top">
                  <a
                    data-w-id="786b13da-3196-a1c8-f674-c1b7d437c3dd"
                    href="https://www.linkedin.com/in/lukas-rudrof/"
                    target="_blank"
                    className="button-author is-text-link w-inline-block"
                  >
                    <div className="button-link-content">
                      <div>Contact Us</div>
                      <div className="button-arrow-wrapper">
                        <div className="icon-1x1-small-2 w-embed">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth={2}
                            stroke="currentColor"
                            className="w-6 h-6"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3"
                            />
                          </svg>
                        </div>
                        <div
                          style={{
                            WebkitTransform:
                              "translate3d(-100%, 0, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                            MozTransform:
                              "translate3d(-100%, 0, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                            msTransform:
                              "translate3d(-100%, 0, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                            transform:
                              "translate3d(-100%, 0, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)"
                          }}
                          className="icon-1x1-small-second w-embed"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth={2}
                            stroke="currentColor"
                            className="w-6 h-6"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3"
                            />
                          </svg>
                        </div>
                      </div>
                    </div>
                    <div className="button-underline">
                      <div
                        style={{ width: 0 }}
                        className="button-underline-progress"
                      />
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</>

   
    </div>
    </body>
  );
};
